import React from "react";
import Link from "next/link";
import Card from "./card";
import { getAssets } from "@unisearch/helpers";
import styles from "./ui-element.module.scss";

const MentorsCard = ({ item, type, customClasses }) => {
  return (
    <div
      className={`${styles.card_wrapper} ${
        customClasses?.root ? customClasses?.root : ""
      }`}
    >
      <div className={styles.img_wrapper}>
        {type == "counsellor" && (
          <img
            src={
              item?.profileImageSrc
                ? item?.profileImageSrc
                : getAssets("assets/counsellor-avatar-small.png")
            }
            alt={`${item?.firstName} ${item?.middleName} ${item?.lastName}`}
          />
        )}
        {type == "mentor" && (
          <img
            src={
              item?.image
                ? item?.image?.src
                : getAssets("assets/mentor-avatar-small.png")
            }
            alt={`${item?.firstName} ${item?.middleName} ${item?.lastName}`}
          />
        )}
        {item?.status === true ? (
          <BsFillPatchCheckFill className={styles.status_icon} />
        ) : null}
      </div>

      <h5>{`${item?.firstName} ${item?.middleName} ${item?.lastName}`}</h5>
      <p>{item?.country_info?.name ?? ""}</p>
      {/*<p>{item.university}</p>*/}
      <div className={styles.btn_wrapper}>
        <Link legacyBehavior href={`/app/student/${type}/${item?.id}`}>
          <a className="btn btn-primary">View Profile</a>
        </Link>
      </div>
    </div>
  );
};

export default MentorsCard;
